export enum SystemSettingsEnum {
	MobileBanner = 'mobile_banner',
	MobileBannerAustin = 'mobile_banner_austin',
	MobileBannerMiami = 'mobile_banner_miami',
	MobileBannerDenver = 'mobile_banner_denver',
	LandingTravisRunResults = 'landing_travisrun_results',
	LandingTravisRunFallback = 'landing_travisrun_fallback',
	EnableShapedAiGlobally = 'enable_shaped_ai_globally',
	EnableCampaignsSectionGlobally = 'mobile_campaigns_section_enabled',
	EnableIosRateModalGlobally = 'mobile_enable_app_review_request',
	EditorPickFeedName = 'editor_pick_feed_name',
}
